<template>
  <div class="position-relative">
    <MeetingBase
      ref="meetingBase"
      :meetingInfo="meetingInfo"
      v-model="tab"
      :searchTabOpts="searchTabOpts"
      @change="tabChange"
    />
    <div
      class="meeting-container"
      :style="`--meetingBaseHeight:${meetingBaseHeight}px;`"
    >
      <div style="margin-bottom: 10px" v-if="tab == 'MI'">
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 16 }"
            :lg="{ span: 16 }"
            class="mt-2"
          >
            <div class="wrapper_box">
              <div class="mb-2" style="font-size: 16px; font-weight: 600">
                {{ $l('collapse_label_topics') || '会议议题' }}
              </div>
              <MeetingTopics :value="meetingInfo.meetingTopics" />
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 8 }"
            :lg="{ span: 8 }"
            class="mt-2"
          >
            <div class="wrapper_box">
              <div class="mb-2" style="font-size: 16px; font-weight: 600">
                {{ $l('collapse_meeting_schedule') || '会议安排' }}
              </div>
              <MeetingAttendance :meetingInfo="meetingInfo" />
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="tab == 'MP'">
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 16 }"
            :lg="{ span: 16 }"
            class="mt-2"
          >
            <div class="wrapper_box">
              <div class="group_head_title mb-2">
                <div class="f1">
                  <div class="name">
                    {{ $l('tip_label_preparatoryTasks') || '会议准备任务' }}
                  </div>
                  <div class="desc">
                    {{
                      $l('tips_label_preparatoryTasks_desc') ||
                        '会议行程及会议准备工作任务安排'
                    }}
                  </div>
                </div>
                <div class="d-flex group_button_wrapper">
                  <div class="group_button" v-if="showButton">
                    <el-button
                      class="ml-2 button_info"
                      type="primary"
                      icon="el-icon-date"
                      size="mini"
                      @click.stop="() => $refs.taskTable.addTask()"
                    >
                      <span>
                        {{ $l('btn_addTask') || '添加任务' }}
                      </span>
                    </el-button>
                    <el-badge
                      :value="checkedMPTaskCount"
                      :hidden="!checkedMPTaskCount"
                    >
                      <el-button
                        class="ml-2 button_success"
                        type="success"
                        icon="el-icon-date"
                        size="mini"
                        @click.stop="dispatchMPTask"
                        :disabled="!checkedMPTaskCount"
                      >
                        <span>
                          {{ $l('btn_dispatchTask') || '任务下发' }}
                        </span>
                      </el-button>
                    </el-badge>
                  </div>
                </div>
              </div>
              <TaskTable
                ref="taskTable"
                :key="'taskTable-MP'"
                v-if="tab == 'MP'"
                :expoMeetingCode="expoMeetingCode"
                :expoInfoCode="expoInfoCode"
                :meetingTaskNode="'B'"
                class="pt-0"
                :disabled="!showButton"
                :height="getHeight()"
                @checkbox-change="(e) => (checkedMPTasks = e)"
              />
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 8 }"
            :lg="{ span: 8 }"
            class="mt-2"
          >
            <div class="wrapper_box">
              <div class="group_head_title mb-2">
                <div class="f1">
                  <div class="name">
                    {{ $l('collapse_label_doc') || '会议资料' }}
                  </div>
                  <div class="desc">
                    {{ $l('tips_label_doc_desc') || '会议所需的相关资料文档' }}
                  </div>
                </div>
                <div class="d-flex group_button_wrapper">
                  <div class="group_button" v-if="showButton">
                    <el-button
                      class="ml-2 button_info"
                      type="primary"
                      icon="el-icon-upload2"
                      size="mini"
                      @click.stop="() => $refs.meetingDoc.uploadFile()"
                    >
                      <span>
                        {{ $l('btn_uploadDoc') || '上传文件' }}
                      </span>
                    </el-button>
                  </div>
                </div>
              </div>
              <MeetingDoc
                ref="meetingDoc"
                :key="'meetingDoc'"
                v-if="tab == 'MP'"
                :expoMeetingCode="expoMeetingCode"
                :customStyle="`height:${getHeight()}px;overflow: auto;`"
              />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="mt-2">
          <el-col :span="24">
            <div class="wrapper_box">
              <div class="group_head_title mb-2">
                <div class="d-flex align-items-end">
                  <div class="name mr-2">
                    {{ $l('collapse_label_sapmle') || '会议选品' }}
                  </div>
                  <div class="desc">
                    {{ $l('tips_label_sapmle_desc') || '本次会议所准备的样品' }}
                  </div>
                </div>
              </div>
              <MeetingSapmleTable
                :expoMeetingCode="expoMeetingCode"
                :expoInfoCode="expoInfoCode"
                class="pt-0"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="tab == 'MC'">
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 16 }"
            :lg="{ span: 16 }"
            class="mt-2"
          >
            <div class="wrapper_box">
              <div class="group_head_title mb-2">
                <div class="f1">
                  <div class="name mr-2">
                    {{ $l('tips_label_comments') || '会议纪要' }}
                  </div>
                  <div class="desc">
                    {{
                      $l('tips_label_comments_desc') ||
                        '会议过程中记录的客户提出的相关问题'
                    }}
                  </div>
                </div>
              </div>
              <CommentsCard
                ref="comments"
                :expoMeetingCode="expoMeetingCode"
                recordType="M"
                :show-title="false"
                :customStyle="`--height:600px`"
              />
            </div>
            <MessageEditor
              :readonly="!showButton"
              :expoMeetingCode="expoMeetingCode"
              :expoInfoCode="expoInfoCode"
              @getData="commentsGetData()"
            />
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 8 }"
            :lg="{ span: 8 }"
            class="mt-2"
          >
            <div class="wrapper_box">
              <div
                class="group_head_title mb-2"
                style="padding: 0px 10px 0px 0px"
              >
                <div class="f1">
                  <div class="name">
                    {{ $l('tips_label_customer_doc') || '客户文档' }}
                  </div>
                  <div class="desc">
                    {{
                      $l('tips_label_customer_doc_desc') ||
                        '会议中客户提供的相关资料文档'
                    }}
                  </div>
                </div>
                <div class="d-flex group_button_wrapper">
                  <div class="group_button" v-if="showButton">
                    <el-button
                      class="ml-2 button_info"
                      type="primary"
                      icon="el-icon-upload2"
                      size="mini"
                      @click.stop="() => $refs.customerDoc.uploadFile()"
                    >
                      <span>
                        {{ $l('btn_uploadDoc') || '上传文件' }}
                      </span>
                    </el-button>
                  </div>
                </div>
              </div>
              <MeetingDoc
                ref="customerDoc"
                :key="'customerDoc'"
                v-if="tab == 'MC'"
                :isCustomer="'Y'"
                :expoMeetingCode="expoMeetingCode"
                :customStyle="`height:777px;overflow: auto;`"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="tab == 'CS'">
        <el-row :gutter="10" class="mt-2">
          <el-col :span="24">
            <div class="wrapper_box">
              <div class="group_head_title mb-2">
                <div class="d-flex align-items-end">
                  <div class="name mr-2">
                    {{ $l('tips_label_customer_sapmle') || '客户选品' }}
                  </div>
                  <div class="desc">
                    {{
                      $l('tips_label_customer_sapmle_desc') ||
                        '本次会议客户选中的产品'
                    }}
                  </div>
                </div>
              </div>
              <SapmleTable
                :expoMeetingCode="expoMeetingCode"
                :expoMeetingStatus="meetingInfo.expoMeetingStatus"
                :custCode="meetingInfo.custCode"
                :custName="meetingInfo.custName"
                class="pt-0"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="tab == 'PMT'">
        <el-row :gutter="10" class="mt-2">
          <el-col :span="24">
            <div class="wrapper_box">
              <div class="group_head_title mb-2">
                <div class="f1">
                  <div class="name">
                    {{ $l('tip_label_postMeetingTasks') || '会后任务安排' }}
                  </div>
                  <div class="desc">
                    {{
                      $l('tips_label_postMeetingTasks_desc') ||
                        '会议结束后，针对本次会议内容指派相关任务'
                    }}
                  </div>
                </div>
                <div class="d-flex group_button_wrapper">
                  <div class="group_button" v-if="showButton">
                    <el-button
                      class="ml-2 button_info"
                      type="primary"
                      icon="el-icon-date"
                      size="mini"
                      @click.stop="
                        () => $refs.taskTablePMT.addPostMeetingTask()
                      "
                    >
                      <span>
                        {{ $l('btn_addTask') || '添加任务' }}
                      </span>
                    </el-button>
                    <el-button
                      class="ml-2 button_danger"
                      type="danger"
                      icon="el-icon-date"
                      size="mini"
                      @click.stop="closeMeeting"
                    >
                      <span>
                        {{ $l('btn_meetingEnd') || '会议结束' }}
                      </span>
                    </el-button>
                    <el-badge
                      :value="checkedPMTTaskCount"
                      :hidden="!checkedPMTTaskCount"
                    >
                      <el-button
                        class="ml-2 button_success"
                        type="success"
                        icon="el-icon-date"
                        size="mini"
                        @click.stop="dispatchPMTTask"
                        :disabled="!checkedPMTTaskCount"
                      >
                        <span>
                          {{ $l('btn_dispatchTask') || '任务下发' }}
                        </span>
                      </el-button>
                    </el-badge>
                  </div>
                </div>
              </div>
              <TaskTable
                ref="taskTablePMT"
                :key="'taskTable-PMT'"
                v-if="tab == 'PMT'"
                :autoHeight="true"
                :expoMeetingCode="expoMeetingCode"
                :expoInfoCode="expoInfoCode"
                :meetingTaskNode="'E'"
                class="pt-0"
                :disabled="!showButton"
                @checkbox-change="(e) => (checkedPMTTasks = e)"
              />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import MeetingBase from './components/meeting-base'
import MeetingTopics from './components/meeting-topics'
import MeetingAttendance from './components/meeting-attendance'
import MeetingDoc from './components/meeting-doc'
import CommentsCard from './components/comments-card'
import SapmleTable from './components/sapmle-table'
import TaskTable from './components/task-table'
import MeetingSapmleTable from './components/meeting-sapmle-table'
import MessageEditor from './components/message-editor'
import EditLoading from '@/mixins/edit-loading'
const vipIcon = require('./icon/vip.png')
const shopIcon = require('./icon/shop.png')
export default {
  name: 'expo-meetingSet-detail',
  mixins: [EditLoading],
  components: {
    MeetingBase,
    MeetingTopics,
    MeetingAttendance,
    MeetingDoc,
    CommentsCard,
    SapmleTable,
    TaskTable,
    MeetingSapmleTable,
    MessageEditor,
  },
  data() {
    return {
      meetingInfo: {},
      localTimeZone: '',
      vipIcon,
      shopIcon,
      meetingBaseHeight: 0,
      containerHeight: 0,
      tab: 'MI',
      checkedMPTasks: [],
      checkedPMTTasks: [],
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    expoMeetingCode() {
      return this.params.expoMeetingCode
    },
    expoInfoCode() {
      return this.params.expoInfoCode
    },
    showButton() {
      return (
        this.meetingInfo.expoMeetingStatus != 'E' &&
        this.meetingInfo.expoMeetingStatus != 'D'
      )
    },
    searchTabOpts() {
      return [
        {
          label: this.$l('btn_meetingInfo') || '会议信息',
          value: 'MI',
        },
        {
          label: this.$l('btn_meetingPreparation') || '会议准备',
          value: 'MP',
        },
        {
          label: this.$l('btn_meetingComments') || '会议纪要',
          value: 'MC',
        },
        {
          label: this.$l('btn_customerSelection') || '客户选品',
          value: 'CS',
        },
        {
          label: this.$l('btn_postMeetingTasks') || '会后任务',
          value: 'PMT',
        },
      ]
    },
    checkedMPTaskCount() {
      return this.checkedMPTasks?.length || 0
    },
    checkedPMTTaskCount() {
      return this.checkedPMTTasks?.length || 0
    },
  },
  async mounted() {
    await this.getData()
    setTimeout(() => {
      window.addEventListener('resize', this.getBaseHeight)
      this.getBaseHeight()
    }, 0)
  },
  destroyed() {
    window.removeEventListener('resize', this.getBaseHeight)
  },
  methods: {
    getHeight() {
      const tableHeight = window.innerHeight - 406
      return tableHeight < 560 ? 560 : tableHeight
    },
    async closeMeeting() {
      const confirm = await this.$confirm(
        this.$l('tips_close_meeting') || '是否要结束会议？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .expoMeetingEndApi({ expoMeetingCode: this.expoMeetingCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getData()
      if (this.$refs.taskTablePMT) this.$refs.taskTablePMT.getData()
      if (this.$refs.taskTable) this.$refs.taskTable.getData()
    },
    getBaseHeight() {
      const $meetingBase = this.$refs.meetingBase
      if (!$meetingBase) return

      const meetingBaseHeight = $meetingBase.$el.clientHeight
      this.meetingBaseHeight = (meetingBaseHeight || 0) + 10

      const main = document.querySelector('.layout-theme-container-main-body')
      const mainHeight = main.clientHeight
      this.containerHeight = mainHeight
    },
    async getData() {
      if (!this.expoMeetingCode) return
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .expoMeetingDetailApi({
          expoMeetingCode: this.expoMeetingCode,
          localTimeZone,
        })
        .catch(() => null)
      if (!res) return
      this.meetingInfo = res.body
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${
          offsetMinutes >= 0 ? '-' : '+'
        }${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    commentsGetData() {
      this.$refs.comments.getData()
    },
    tabChange() {
      this.checkedMPTasks = []
      this.checkedPMTTasks = []
    },
    async dispatchMPTask() {
      if (!this.checkedMPTaskCount) return

      const listTskInfoCode = this.checkedMPTasks.map((row) => row.tskInfoCode)

      const confirm = await this.$confirm(
        this.$l('tips_confirm_dispatchTask') || '是否确认下发任务？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX._btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .expoTskInfoMeetingDispatchApi({ listTskInfoCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_dispatchTask_no') || '下发失败！')
        return
      }
      this.$message({
        message: this.$l('tips_dispatchTask_ok') || '下发成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.$refs.taskTable.getData()
      this.$refs.taskTable.clearCheckboxRow()
    },
    async dispatchPMTTask() {
      if (!this.checkedPMTTaskCount) return

      const listTskInfoCode = this.checkedPMTTasks.map((row) => row.tskInfoCode)

      const confirm = await this.$confirm(
        this.$l('tips_confirm_dispatchTask') || '是否确认下发任务？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX._btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .expoTskInfoMeetingDispatchApi({ listTskInfoCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_dispatchTask_no') || '下发失败！')
        return
      }
      this.$message({
        message: this.$l('tips_dispatchTask_ok') || '下发成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.$refs.taskTablePMT.getData()
      this.$refs.taskTablePMT.clearCheckboxRow()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tag--High {
    color: white;
    background-color: #fa5c7c;
    border: none;
  }
  .el-tag--Medium {
    color: white;
    background-color: #6c757d;
    border: none;
  }
  .el-tag--Low {
    color: white;
    background-color: #13cf97;
    border: none;
  }
  .el-tag--Y {
    color: #fa561f;
    background-color: #fff2e8;
    border-color: rgba($color: #fa561f, $alpha: 0.6);
  }
}
</style>
<style lang="scss" scoped>
.meeting-base_wrapper {
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  background-color: white;
  // z-index: 999;
  border-radius: 5px;
  padding: 10px 15px;
}
.meeting-container {
  z-index: 1;
  --meetingBaseHeight: 136px;
  // padding-top: var(--meetingBaseHeight);
  overflow-x: hidden;
  .meeting_tags {
    display: flex;
    align-items: center;
    color: rgba(79, 79, 79, 1);
    font-size: 14px;
    font-weight: 600;
    .meeting-icon {
      margin-right: 2px;
      width: 24px;
      height: 24px;
    }
  }
}
.align-items-end {
  align-items: end;
}
.group_head_title {
  display: flex;
  .f1 {
    flex: 1;
  }
  .name {
    font-size: 16px;
    color: #101010;
    font-weight: 600;
  }
  .desc {
    font-size: 12px;
    color: #8e8e8e;
  }
  .group_button_wrapper {
    align-items: center;
    .group_button {
      display: flex;
      .el-button {
        height: 38px;
      }
    }
  }
}
.wrapper_box {
  padding: 15px;
  background: white;
  border-radius: 5px;
}
.button_info {
  background-color: #18c5bd;
  border: 1px solid #18c5bd;
  font-weight: 600;
  font-size: 14px;
}
.button_danger {
  background-color: #ffe2e5;
  border: 1px solid #ffe2e5;
  color: #f54e60;
  font-weight: 600;
  font-size: 14px;
}
.button_success {
  font-weight: 600;
  font-size: 14px;
}
</style>
